// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-header {
  color: #53aae5;
  border-block-color: rgb(88, 91, 92);
  font-size: large;
}

.agentReviewApplndata {
  display: flex;
  margin-bottom: 20px;
}
.agentReviewApplndata label {
  min-width: 50%;
  margin-right: 15px;
  word-wrap: break-word;
}
.agentReviewApplndata span {
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  width: 100%;
}

.note-button-div {
  position: fixed;
  z-index: 9999;
  right: 0px;
  top: 300px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.note-button {
  background-color: #274bdb;
  color: #fff;
}

.note-button:hover {
  width: 125px;
  background-color: #768ff5;
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.2);
  color: rgb(255, 255, 255);
  transition: 0.3s;
}

.note-button:active {
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  transition: 0.05s;
}`, "",{"version":3,"sources":["webpack://./src/app/agent/agent-review-application/agent-review-application.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,mCAAA;EACA,gBAAA;AACF;;AACA;EACE,aAAA;EACA,mBAAA;AAEF;AADE;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;AAGJ;AADE;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,WAAA;AAGJ;;AAAA;EACE,eAAA;EACA,aAAA;EACA,UAAA;EACA,UAAA;EACA,4EAAA;AAGF;;AADA;EACE,yBAAA;EACA,WAAA;AAIF;;AAFA;EACE,YAAA;EACA,yBAAA;EACA,0CAAA;EACA,yBAAA;EACA,gBAAA;AAKF;;AAFA;EACE,0CAAA;EACA,iBAAA;AAKF","sourcesContent":[".card-header {\r\n  color: #53aae5;\r\n  border-block-color: rgb(88, 91, 92);\r\n  font-size: large;\r\n}\r\n.agentReviewApplndata {\r\n  display: flex;\r\n  margin-bottom: 20px;\r\n  label {\r\n    min-width: 50%;\r\n    margin-right: 15px;\r\n    word-wrap: break-word;\r\n  }\r\n  span {\r\n    flex-grow: 1;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: inline-block;\r\n    width: 100%;\r\n  }\r\n}\r\n.note-button-div {\r\n  position: fixed;\r\n  z-index: 9999;\r\n  right: 0px;\r\n  top: 300px;\r\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\r\n}\r\n.note-button {\r\n  background-color: #274bdb;\r\n  color: #fff;\r\n}\r\n.note-button:hover {\r\n  width: 125px;\r\n  background-color: #768ff5;\r\n  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.2);\r\n  color: rgb(255, 255, 255);\r\n  transition: 0.3s;\r\n}\r\n\r\n.note-button:active {\r\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);\r\n  transition: 0.05s;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
